import { SweetAlertResult } from 'sweetalert2';
import { makeStyles, Theme } from '@material-ui/core/styles';
import getBaseSweetAlert from './get-base-sweet-alert';
import { SweetAlertHookApi, OpenAlertOptions } from 'types';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    ...theme.typography.h4
  },
  container: {
    zIndex: theme.zIndex.modal + 1
  },
  content: {
    ...theme.typography.body2,
    marginTop: theme.spacing(2),
    fontWeight: 300,
    fontSize: '1.125em'
  },
  popup: {
    width: '28em',
    borderRadius: '8px'
  },
  alertContainer: {
    zIndex: theme.zIndex.modal + 1
  },
  alertContent: {
    ...theme.typography.body2,
    fontWeight: 300,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: '1.125rem',
    color: theme.palette.common.black,
    '& > p': {
      margin: 0
    }
  },
  alertActions: {
    marginTop: 0
  },
  alertIcon: {
    marginBottom: theme.spacing(2)
  },
  alertTitle: {
    ...theme.typography.h2,
    fontFamily: theme.typography.fontFamily,
    marginTop: '0px'
  },
  alertConfirmButton: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    backgroundColor: `${theme.palette.primary.main} !important`,
    borderRadius: '24px !important',
    padding: `${theme.spacing(1.375)}px ${theme.spacing(3.5)}px`,
    outline: 'none !important'
  },
  alertCancelButton: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    backgroundColor: `${theme.palette.common.white} !important`,
    color: `${theme.palette.grey[800]} !important`,
    border: `solid 1px ${theme.palette.grey[500]} !important`,
    padding: `${theme.spacing(1.375)}px ${theme.spacing(3.5)}px`,
    borderRadius: '24px !important'
  }
}));

const useWarningAlert = (): SweetAlertHookApi => {
  const classes = useStyles();
  const SweetAlert = getBaseSweetAlert({
    icon: 'warning',
    showConfirmButton: true,
    showCancelButton: true,
    showCloseButton: false,
    reverseButtons: true,
    customClass: {
      container: classes.alertContainer,
      content: classes.alertContent,
      title: classes.alertTitle,
      actions: classes.alertActions,
      icon: classes.alertIcon,
      popup: classes.popup,
      cancelButton: classes.alertCancelButton,
      confirmButton: classes.alertConfirmButton
    }
  });

  const open = (
    { onCancel, onSubmit, ...rest }: OpenAlertOptions = {} as OpenAlertOptions
  ): Promise<SweetAlertResult | void> => {
    return SweetAlert.fire({
      ...rest
    }).then(async (result: SweetAlertResult | void) => {
      if (result && result.value && onSubmit) {
        return onSubmit(result);
      } else if (onCancel) {
        return onCancel();
      }
    });
  };

  return {
    open
  };
};

export default useWarningAlert;
